export const errorHelper = { isError };

function isError(e) {
  let isErr = e instanceof Error;

  return isErr;
}
